import { render } from "./RecognitionSection.vue?vue&type=template&id=058f9781"
import script from "./RecognitionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RecognitionSection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/RecognitionSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "058f9781"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('058f9781', __exports__)) {
    api.reload('058f9781', __exports__)
  }
  
  module.hot.accept("./RecognitionSection.vue?vue&type=template&id=058f9781", () => {
    api.rerender('058f9781', render)
  })

}


export default __exports__